var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TitleWithBackButton',{attrs:{"title":"Impostazioni","back-route":"Homepage","icon":"mdi-graphql"}}),_c('SettingsHome',{style:({
      'pointer-events': _vm.canManageSettings ? 'all' : 'none',
      opacity: _vm.canManageSettings ? '1' : '0.2',
    })}),(_vm.showErrorDialog)?_c('ErrorDialogComponent',{attrs:{"open-dialog":_vm.showErrorDialog,"title":"Utente non abilitato","error-message":_vm.errorMessage},on:{"close-error":_vm.goBack}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }